import script from "./ProductFeaturesSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFeaturesSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductFeaturesSkeleton.vue?vue&type=style&index=0&id=a9786a4c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9786a4c"]])

export default __exports__